import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

class LoginButtons extends React.Component {
  renderButton = (classes, href, className, text) => (
    <div className={cn('columns medium-6 small-12', classes.name)}>
      <a href={href} className={cn(className)}>
        {text}
      </a>
    </div>
  );

  render() {
    const { classes } = this.props;

    return (
      <div className={cn(classes.donationLabelsSpacer)}>
        <div className={cn(classes.subtitle)}>
          To get started, login to your account so we can track your donation
        </div>
        <div className={cn('row', classes.nameContainer)}>
          {this.renderButton(classes, '/customer/account/create', 'button action expand', 'Create New Account')}
          {this.renderButton(classes, '/customer/account/login', 'button action primary expand', 'Login')}
        </div>
      </div>
    );
  }
}

LoginButtons.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default (LoginButtons);
